import clsx from 'clsx'
import {useFormik} from 'formik'
import React, {useState} from 'react'
import {Button, Modal} from 'react-bootstrap'
import Select from 'react-select'
import * as Yup from 'yup'
import {KTSVG} from '../../../../../_metronic/helpers'
import DeleteButton from '../../../../shared/actionButtons/DeleteButton'
import DeleteModals from '../DeleteModals'
import HelpBubble from '../utils/HelpBubble'

const titleSchama = Yup.object().shape({
  years: Yup.string().required('This field is required'),
})

const initialValues = {
  years: '',
}
type Props = {
  editModal: boolean
  handleEditModal: () => void
}

function SkillsModal({editModal, handleEditModal}: Props) {
  const [deleteModal, setdeleteModal] = useState(false)
  const [activeSkill, setactiveSkill] = useState<string>('')
  const [newSkills, setNewSkills] = useState<any>([])

  const handleDeleteModal = () => {
    setdeleteModal(!deleteModal)
  }

  const formik = useFormik({
    initialValues,
    validationSchema: titleSchama,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      try {
        //call action here
      } catch (error) {
        console.error(error)
      }
    },
  })
  const skillOptions = [
    {value: 'Node js', label: 'Chocolate'},
    {value: 'React Js', label: 'React Js'},
    {value: 'Mongo Db', label: 'Mongo Db'},
    {value: 'Nest', label: 'Nest'},
    {value: 'Next Js', label: 'Next Js'},
    {value: 'Javascript', label: 'Javascript'},
    {value: 'java', label: 'Java'},
    {value: 'Flutter', label: 'Flutter'},
    {value: 'Kotlin', label: 'Kotlin'},
    {value: 'Java-android development', label: 'Java-android development'},
  ]
  const competancyOptions = [
    {value: 'Beginner', label: 'Beginner'},
    {value: 'Intermediate', label: 'Intermediate'},
    {value: 'Experienced', label: 'Experienced'},
    {value: 'Advanced', label: 'Advanced'},
  ]
  return (
    <Modal show={editModal} onHide={handleEditModal} size={'lg'}>
      <Modal.Header closeButton>
        <Modal.Title>Edit your skillset</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <DeleteModals
          handleDeleteModal={handleDeleteModal}
          title={activeSkill}
          deleteModal={deleteModal}
        />

        <form onSubmit={formik.handleSubmit} noValidate>
          <div className='py-4'>
            <HelpBubble
              icon='/media/icons/duotune/general/gen045.svg'
              text='Add your skills, years of experience and how competent you are with each of them.'
            />
          </div>

          <div className='table-responsive'>
            <table className='table align-middle gs-0 gy-3'>
              {/* begin::Table head */}
              <thead>
                <tr>
                  <th className='p-0 min-w-150px fw-bold fs-6'>Skill</th>
                  <th className='p-0 min-w-150px fw-bold fs-6'>Years Of Experience</th>
                  <th className='p-0 min-w-150px fw-bold fs-6'>Competency</th>
                  <th className='p-0 min-w-70px '></th>
                </tr>
              </thead>
              {/* end::Table head */}
              {/* begin::Table body */}
              <tbody>
                <tr>
                  <td>
                    <Select menuPosition={'fixed'} menuPlacement='top' options={skillOptions} />
                  </td>
                  <td>
                    <input
                      {...formik.getFieldProps('years')}
                      placeholder='years of expereince'
                      className={clsx(
                        'form-control form-control-lg form-control-solid',
                        {'is-invalid': formik.touched.years && formik.errors.years},
                        {
                          'is-valid': formik.touched.years && !formik.errors.years,
                        }
                      )}
                      type='text'
                      name='years'
                      autoComplete='off'
                    />
                    {formik.touched.years && formik.errors.years && (
                      <div className='fv-plugins-message-container'>
                        <span role='alert'>{formik.errors.years}</span>
                      </div>
                    )}
                  </td>
                  <td>
                    <Select
                      menuPosition={'fixed'}
                      menuPlacement='top'
                      options={competancyOptions}
                    />
                  </td>
                  <td>
                    <DeleteButton
                      handleDeleteModal={handleDeleteModal}
                      setActive={setactiveSkill}
                      activeItem={'Wolkite university from your education list?'}
                      className='mx-2'
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Select menuPosition={'fixed'} menuPlacement='top' options={skillOptions} />
                  </td>
                  <td>
                    <input
                      {...formik.getFieldProps('years')}
                      placeholder='years of expereince'
                      className={clsx(
                        'form-control form-control-lg form-control-solid',
                        {'is-invalid': formik.touched.years && formik.errors.years},
                        {
                          'is-valid': formik.touched.years && !formik.errors.years,
                        }
                      )}
                      type='text'
                      name='years'
                      autoComplete='off'
                    />
                    {formik.touched.years && formik.errors.years && (
                      <div className='fv-plugins-message-container'>
                        <span role='alert'>{formik.errors.years}</span>
                      </div>
                    )}
                  </td>
                  <td>
                    <Select
                      menuPosition={'fixed'}
                      menuPlacement='top'
                      options={competancyOptions}
                    />
                  </td>
                  <td>
                    <DeleteButton
                      handleDeleteModal={handleDeleteModal}
                      setActive={setactiveSkill}
                      activeItem={'Wolkite university from your education list?'}
                      className='mx-2'
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Select menuPosition={'fixed'} menuPlacement='top' options={skillOptions} />
                  </td>
                  <td>
                    <input
                      {...formik.getFieldProps('years')}
                      placeholder='years of expereince'
                      className={clsx(
                        'form-control form-control-lg form-control-solid',
                        {'is-invalid': formik.touched.years && formik.errors.years},
                        {
                          'is-valid': formik.touched.years && !formik.errors.years,
                        }
                      )}
                      type='text'
                      name='years'
                      autoComplete='off'
                    />
                    {formik.touched.years && formik.errors.years && (
                      <div className='fv-plugins-message-container'>
                        <span role='alert'>{formik.errors.years}</span>
                      </div>
                    )}
                  </td>
                  <td>
                    <Select menuPlacement='top' options={competancyOptions} />
                  </td>
                  <td>
                    <DeleteButton
                      handleDeleteModal={handleDeleteModal}
                      setActive={setactiveSkill}
                      activeItem={'Wolkite university from your education list?'}
                      className='mx-2'
                    />
                  </td>
                </tr>
                {newSkills.map(() => (
                  <tr>
                    <td>
                      <Select menuPlacement='top' options={skillOptions} />
                    </td>
                    <td>
                      <input
                        {...formik.getFieldProps('years')}
                        placeholder='years of expereince'
                        className={clsx(
                          'form-control form-control-lg form-control-solid',
                          {'is-invalid': formik.touched.years && formik.errors.years},
                          {
                            'is-valid': formik.touched.years && !formik.errors.years,
                          }
                        )}
                        type='text'
                        name='years'
                        autoComplete='off'
                      />
                      {formik.touched.years && formik.errors.years && (
                        <div className='fv-plugins-message-container'>
                          <span role='alert'>{formik.errors.years}</span>
                        </div>
                      )}
                    </td>
                    <td>
                      <Select menuPlacement='top' options={competancyOptions} />
                    </td>
                    <td>
                      <DeleteButton
                        handleDeleteModal={handleDeleteModal}
                        setActive={setactiveSkill}
                        activeItem={'Wolkite university from your education list?'}
                        className='mx-2'
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <button
              className='btn btn-primary  btn-sm'
              onClick={() => setNewSkills([...newSkills, '0'])}
            >
              {' '}
              <KTSVG
                path='/media/icons/duotune/general/gen035.svg'
                className='svg-icon-3 svg-icon-success mr-2 '
              />{' '}
              Add new
            </button>
            <div className='fv-row mb-10'></div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={handleEditModal}>
          Close
        </Button>
        <Button type='submit' disabled={formik.isSubmitting || !formik.isValid} variant='primary'>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default SkillsModal
